import {
  GeneratedArtifact,
  GeneratedArtifactType,
  GeneratedPodcastStageStatus,
} from '@kimuno/api-sdk/lib/types/responses/Ai';

export const isGeneratingPodcastArtifact = (artifact: GeneratedArtifact): boolean =>
  artifact.type === GeneratedArtifactType.PODCAST &&
  artifact.status === GeneratedPodcastStageStatus.LOADING;
